module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancelLabel":"Cancel","title":"Search for Clerk","chooseClerk":"Choose Clerk","searchPlaceholder":"Search text","name":"Name","email":"Mail"},"no":{"cancelLabel":"Avbryt","title":"Søk etter ansvarlig","chooseClerk":"Velg ansvarlig","searchPlaceholder":"Søketekst","name":"Navn","email":"Mail"}}')
  delete Component.options._Ctor
}
